export default __webpack_public_path__ + "static/media/ret_sta_4.1aade492.jpeg";